import api from '../../services/ApiService';


export async function sendEmailNotification(params) {
  const { data } = await api.post('send-email', params);
  return data;
}
